import React, { FC } from 'react'

import { IconDocumentJpgProps } from './IconDocumentJpg.types'
import * as Styled from './styles/IconDocumentJpg.style'

import { nonThemeableRules } from '../../ruleSet'

const IconDocumentJpg: FC<IconDocumentJpgProps> = ({
  size = nonThemeableRules.defaultSize as number as IconDocumentJpgProps['size'],
  isResponsive = false,
}: IconDocumentJpgProps) => {
  return (
    <Styled.IconWrapper size={size} isResponsive={isResponsive}>
      <svg fill='none' viewBox='0 0 48 48' xmlns='http://www.w3.org/2000/svg'>
        <g clipPath='url(#56e0ec09-0ba7-4612-afdb-9ea1aeb010a7__a)' strokeLinecap='round' strokeWidth='2'>
          <path d='M11.467 13.017h7.53V6.015' stroke='#0D0D0D' strokeLinejoin='round' />
          <path
            d='M20.707 5.075a4.265 4.265 0 0 0-2.774 1.027l-5.408 4.648a4.25 4.25 0 0 0-1.485 3.225v24.93c0 2.2 1.8 4 3.48 4h18.44c2.72 0 4-1.8 4-4V5.075H20.707Z'
            stroke='#0D0D0D'
            strokeMiterlimit='10'
          />
          <path
            d='M21.85 29.208v-6.1h1.777s1.78-.128 1.78 1.78c0 1.907-1.78 1.777-1.78 1.777H21.85m-3.815-3.558v5.105a1 1 0 0 1-.345.765c-.385.327-1.095.652-2.195.102m15.615-2.474h1.27v2.475s-3.468 1.185-3.968-1.867c-.5-3.095 1.473-3.735 1.86-3.828.228-.055 1.548-.25 1.98.75'
            stroke='#E60000'
            strokeLinejoin='round'
          />
        </g>
        <defs>
          <clipPath id='56e0ec09-0ba7-4612-afdb-9ea1aeb010a7__a'>
            <path d='M0 0h48v48H0z' fill='#fff' />
          </clipPath>
        </defs>
      </svg>
    </Styled.IconWrapper>
  )
}

export default IconDocumentJpg
